export const intlConversionIdsByLocale = {
  nz: "991328312",
  au: "991328312",
  gb: "993775467",
  eu: "967281443",
  es: "10827045163",
  fr: "978464973",
  de: "996767380",
  kr: "11117728198",
  hk: "858909422",
  jp: "11088302785",
} as const;

export const usConversionId = "855376633";
export const canadaConversionId = "855376142";

export const emeaManagerConversionId = "16691803251";
export const namManagerConversionId = "855782001";
// export const managerConversionIdsByLocale = {
//   mx: namManagerConversionId,
//   gb: emeaManagerConversionId,
//   de: emeaManagerConversionId,
// };

export const namConversionIdsByLocale = {
  mx: "18007017442",
  ca: canadaConversionId,
  default: usConversionId,
} as const;

export const usConversionLabel = "eXnLCLLhonAQ-YXwlwM";
export const canadaConversionLabel = "h9UrCIWHtXAQjoLwlwM";

export const namManagerConversionLabel = "QGbRCP7CxoUZEPHkiJgD";
export const canadaManagerConversionLabel = "k-yTCMfExoUZEPHkiJgD";
export const namManagerConversionLabelByLocale = {
  canada: canadaManagerConversionLabel,
  default: namManagerConversionLabel,
} as const;

export const intlManagerConversionIdsByRegion = {
  de: emeaManagerConversionId,
  gb: emeaManagerConversionId, 
} as const;

export const intlManagerPageViewConversionLabelsByRegion = {
  de: "ct4rCNf_-owaEPPoopc-",
  gb: "6-6mCPXL94waEPPoopc-"
} as const;

export const intlManagerPurchaseConversionLabelsByRegion = {
    de: "IeIPCNnT94waEPPoopc-",
    gb: "mRBBCO_h8uwZEPPoopc-"
};

export const intlManagerAddToCartConversionLabelsByRegion = {
    de: "7KUHCKjb94waEPPoopc-",
    gb: "oXccCLe394waEPPoopc-",
} as const;

export const intlAddToCartConversionLabelsByRegion = {
    jp: "6GrbCOeDlv0BEOuvmOsC",
    hk: "ujJWCIDj_fwBEO7Vx5kD",
    kr: "dG6qCL_qtvwBEP_nl50C",
    de: "77nECPTbo_sCEJTtpdsD",
    fr: "hX7VCK3534AYEM3hyNID",
    es: "YsPACLWc28wDEKuy3qoo",
    eu: "gzhvCNC84YAYEKOWns0D",
    gb: "3YWqCMDKzfsCEOue79kD",
    au: "YasbCI7dp7ICELjw2dgD",
} as const;

export const intlPurchaseConversionLabelsByRegion = {
    jp: "k9MGCMbZ3pEYEMGlqKcp",
    hk: "q88YCKWO23EQ7tXHmQM",
    kr: "J2gmCPbD95EYEMajrLUp",
    de: "_AN9CLyAyWgQlO2l2wM",
    fr: "ikm4CITp7FgQzeHI0gM",
    es: "YZRFCK-c28wDEKuy3qoo",
    eu: "YV3KCOjP7-MDEKOWns0D",
    gb: "WQ2lCIX3oAQQ657v2QM",
    au: "JjRTCP2-rl8QuPDZ2AM",
    nz: "JjRTCP2-rl8QuPDZ2AM",
    mx: "HmZ9CMvo0IYcEOKPtYpD"
} as const;

export const intlPageViewConversionLabelByRegion = {
    jp: "6GrbCOeDlv0BEOuvmOsC",
    hk: "ujJWCIDj_fwBEO7Vx5kD",
    kr: "dG6qCL_qtvwBEP_nl50C",
    de: "77nECPTbo_sCEJTtpdsD",
    fr: "hX7VCK3534AYEM3hyNID",
    es: "YsPACLWc28wDEKuy3qoo",
    eu: "gzhvCNC84YAYEKOWns0D",
    gb:"3YWqCMDKzfsCEOue79kD",
    au: "YasbCI7dp7ICELjw2dgD",
    mx: "GJaaCIeK3IYcEOKPtYpD"
} as const;

export const intlConversionLabels = {
    "add-to-cart": {
        account: intlAddToCartConversionLabelsByRegion,
        manager: intlManagerAddToCartConversionLabelsByRegion
    },
    purchase: {
        account: intlPurchaseConversionLabelsByRegion,
        manager: intlManagerPurchaseConversionLabelsByRegion,
    },
    "page-view": {
        account: intlPageViewConversionLabelByRegion,
        manager: intlManagerPageViewConversionLabelsByRegion,
    },
} as const;

export const namConversionLabels = {
    "add-to-cart": {
        account: {
            default: "HjJGCLi3uJECEPmF8JcD",
            canada:  "TlvpCJSP8JgZEI6C8JcD",
            mx: "7P-oCLnu0IYcEOKPtYpD",
        },
        manager: {
            default: "gcawCIHDxoUZEPHkiJgD",
            canada: "5l9aCMrExoUZEPHkiJgD",
            mx: "0-S8CKG92ZQcEPHkiJgD",
        },
    },
    purchase: {
        account: {
            default: "eXnLCLLhonAQ-YXwlwM",
            canada: "h9UrCIWHtXAQjoLwlwM",
            mx: "HmZ9CMvo0IYcEOKPtYpD",
        },
        manager: {
            default: "QGbRCP7CxoUZEPHkiJgD",
            canada: "k-yTCMfExoUZEPHkiJgD",
            mx: "X6C7CJjiz5QcEPHkiJgD"
        }
    },
    "purchase-customer-type": {
        account: {
            default: "ntWICJ6Z680ZEPmF8JcD",
            canada: "gobBCLue680ZEI6C8JcD"
        },
        manager: {
            default: "vJmqCNnM5M0ZEPHkiJgD",
            canada: "t0c8CJ_R5M0ZEPHkiJgD",
        },
    },
    "email-signup": {
        account: {
            // There is no MCC entry for these
            default: "v1l3CLzxvIIbEPmF8JcD",
            canada: "o3HeCIzTzIIbEI6C8JcD"
        },
    },

    // remarketing
    "page-view": {
        // I don't see any active for US and CA
        // ca: {
        //     default: 
        // },
        account: {
            mx: "GJaaCIeK3IYcEOKPtYpD",
        }
    }
} as const;
